import {
  CashSession,
  ListCashSessionsResponse,
} from '@/@types/cash-management';
import {
  EmptyData,
  ErrorList,
  ListPlaceholder,
  ResponseDataHandle,
  Table,
} from '@/components/common';
import { ITablePaginationProps } from '@/components/common/Table/TablePagination';
import { Box } from '@mui/material';
import {
  CashSessionTableActions,
  CashSessionsTableColumns,
} from './CashSessionsTableColumns';

type CashSessionsListProps = {
  isLoading: boolean;
  isError: boolean;
  data?: ListCashSessionsResponse;
  sort?: 'desc' | 'asc';
  sortBy?: keyof CashSession;
  // eslint-disable-next-line no-unused-vars
  onSort?: (header: string) => void;
  actions: CashSessionTableActions;
  pagination?: ITablePaginationProps;
};

export function CashSessionsList({
  isLoading,
  isError,
  data,
  sort,
  sortBy,
  onSort,
  actions,
  pagination,
}: CashSessionsListProps) {
  return (
    <ResponseDataHandle
      isLoading={isLoading}
      loadingComponent={
        <ListPlaceholder
          headers={['Número', 'Status', 'Aberto em', 'Valores', 'Ações']}
        />
      }
      isError={isError}
      errorComponent={
        <Box py={10}>
          <ErrorList text="Não foi possível carregar as sessões de caixa." />
        </Box>
      }
      totalItems={data?.totalCount}
      emptyComponent={
        <Box py={10}>
          <EmptyData />
        </Box>
      }
    >
      <Table
        data={data?.cashSessions || []}
        columns={CashSessionsTableColumns}
        additionalData={actions}
        sort={sort}
        sortBy={sortBy}
        onSort={onSort}
        pagination={pagination}
      />
    </ResponseDataHandle>
  );
}
